import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/sub-processors.md?raw';

export default function SubProcessorsScreen() {
  return <LegalDoc markdown={markdown} title="Sub-processors" />;
}
